import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js';

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../common/Icon';

const AgentDashboard = ({ setActiveTab }) => {
    const { user } = useAuth();
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user) {
            const q = query(collection(db, "agents"), where("userId", "==", user.uid));
            const unsubscribe = onSnapshot(
                q,
                (querySnapshot) => {
                    const agentsData = querySnapshot.docs.map(doc => ({ 
                        id: doc.id, 
                        ...doc.data() 
                    }));
                    setAgents(agentsData);
                    setLoading(false);
                },
                (error) => {
                    console.error("Error fetching agents: ", error);
                    setAgents([]);
                    setLoading(false);
                }
            );
            return () => {
                if (unsubscribe) {
                    unsubscribe();
                }
            };
        } else {
            setAgents([]);
            setLoading(false);
        }
    }, [user]);

    const callHistoryData = [
        { name: 'Jan', calls: 400 }, { name: 'Feb', calls: 300 },
        { name: 'Mar', calls: 600 }, { name: 'Apr', calls: 800 },
        { name: 'May', calls: 500 }, { name: 'Jun', calls: 700 },
    ];

    if (loading) {
        return <div className="text-center p-10">Loading agents...</div>
    }

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Agent Dashboard</h1>

            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-gray-500 text-sm font-medium">Total Agents</h3>
                    <p className="text-3xl font-bold text-gray-800">{agents.length}</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-gray-500 text-sm font-medium">Total Calls (Month)</h3>
                    <p className="text-3xl font-bold text-gray-800">1,280</p>
                </div>
                 <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-gray-500 text-sm font-medium">Avg. Call Duration</h3>
                    <p className="text-3xl font-bold text-gray-800">2.5 min</p>
                </div>
                 <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-gray-500 text-sm font-medium">Success Rate</h3>
                    <p className="text-3xl font-bold text-green-500">98%</p>
                </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow mb-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Call History</h2>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={callHistoryData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="calls" fill="#818cf8" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-700">Your Agents</h2>
                                            <button onClick={() => setActiveTab('createAgent')} className="bg-[#B67BF4] text-white px-4 py-2 rounded-lg hover:bg-[#7B34BB] transition duration-300 flex items-center space-x-2">
                        <Icon path="M12 4.5v15m7.5-7.5h-15" className="w-5 h-5" />
                        <span>New Agent</span>
                    </button>
                </div>
                {agents.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="border-b">
                                    <th className="p-3">Name</th>
                                    <th className="p-3">Voice</th>
                                    <th className="p-3">Language</th>
                                    <th className="p-3">Status</th>
                                    <th className="p-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agents.map(agent => (
                                    <tr key={agent.id} className="border-b hover:bg-[#7B34BB]/10">
                                        <td className="p-3 font-medium">{agent.name}</td>
                                        <td className="p-3 capitalize">{agent.voice}</td>
                                        <td className="p-3">{agent.language}</td>
                                        <td className="p-3"><span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">Active</span></td>
                                        <td className="p-3">
                                            <button className="text-indigo-600 hover:text-[#7B34BB]">Edit</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-10">
                        <p className="text-gray-500">You haven't created any agents yet.</p>
                        <button onClick={() => setActiveTab('createAgent')} className="mt-4 bg-[#B67BF4] text-white px-4 py-2 rounded-lg hover:bg-[#7B34BB] transition duration-300">Create Your First Agent</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AgentDashboard;

